import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

import {AbstractVisualFeature} from '../../visual-feature.js';
import {CardsAndPromotions} from '../cards-and-promotions.js';

import {matchCardsFactory} from './factory/match-cards.factory.js';
import {selectionCardsFactory} from './factory/selection-cards.factory.js';
import {outrightCardsFactory} from './factory/outright-cards.factory.js';
import {fallbackCardsFactory} from './factory/fallback-cards.factory.js';
import {raceCardsFactory} from './factory/race-cards.factory.js';

import PALETTE_SCHEMA from './event-cards.palette-schema.yaml';

class EventCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'EventCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return {
            EventCardSkeleton: {
                container: {
                    style: {
                        ...resolveBackground(PALETTE.PARENT.CARD_CONTAINER_BG),
                        ...generateBorder(PALETTE.PARENT.CARD_BORDER),
                    },
                },
            },
            ...matchCardsFactory(PALETTE),
            ...selectionCardsFactory(PALETTE),
            ...outrightCardsFactory(PALETTE),
            ...fallbackCardsFactory(PALETTE),
            ...raceCardsFactory(PALETTE),
        };
    }
}

new EventCardsFeature(CardsAndPromotions);
